import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, ThumbsUp, BadgeCheck } from 'lucide-react';
const CARDS = [{
  icon: Headphones,
  title: 'U.S.-Based Dispatch Team',
  desc: 'Talk with people who understand trucking and speak clear English.'
}, {
  icon: ThumbsUp,
  title: 'No Forced Dispatch',
  desc: 'FSG presents options. You decide which loads make sense for your truck.'
}, {
  icon: BadgeCheck,
  title: 'Broker Verification Support',
  desc: 'FSG helps with setup, packets, portals, and paperwork so brokers can verify you faster.'
}];
export function UnderOneRoof() {
  return <section id="dispatch" className="section-padding bg-white" data-id="element-349">
      <div className="container-custom" data-id="element-350">
        <div className="max-w-3xl mb-10" data-id="element-351">
          <h2 className="text-3xl md:text-4xl font-black text-navy mb-4 tracking-tight" data-id="element-352">
            Dispatch, Broker Communication, Paperwork, and Billing Under One
            Roof
          </h2>
          <p className="text-lg text-body font-medium leading-relaxed" data-id="element-353">
            FSG helps with the work that keeps drivers stuck on the phone after
            they should be done for the day: planning loads, talking to brokers,
            handling rate cons, organizing documents, billing, check calls, and
            follow-up.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-354">
          {CARDS.map((card, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-off-white border border-steel rounded-sm p-8 h-full" data-id="element-355">
              <card.icon className="w-7 h-7 text-red mb-4" data-id="element-356" />
              <h3 className="text-lg font-bold text-navy mb-2" data-id="element-357">{card.title}</h3>
              <p className="text-body font-medium leading-relaxed" data-id="element-358">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}